import { render, staticRenderFns } from "./FilesUpload.vue?vue&type=template&id=2499d856&scoped=true"
import script from "./FilesUpload.vue?vue&type=script&lang=js"
export * from "./FilesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2499d856",
  null
  
)

export default component.exports